var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 45.0625C2.02515 42.9203 2.4711 40.8039 3.3125 38.8337C4.23125 36.9944 8.07312 35.7194 12.8956 33.9344C14.1987 33.4506 13.985 30.0456 13.4075 29.41C12.4875 28.4138 11.7887 27.2341 11.357 25.9486C10.9252 24.6631 10.7703 23.3009 10.9025 21.9512C10.8199 21.0923 10.9149 20.2255 11.1817 19.4048C11.4485 18.5842 11.8814 17.8272 12.4533 17.181C13.0253 16.5348 13.7241 16.0133 14.5063 15.6488C15.2885 15.2844 16.1373 15.0848 17 15.0625C17.8633 15.0838 18.713 15.2826 19.496 15.6466C20.2791 16.0106 20.9789 16.532 21.5516 17.1783C22.1244 17.8246 22.5579 18.5819 22.8251 19.4031C23.0924 20.2243 23.1877 21.0917 23.105 21.9512C23.2372 23.3009 23.0823 24.6631 22.6506 25.9486C22.2188 27.2341 21.52 28.4138 20.6 29.41C20.0225 30.0456 19.8087 33.4506 21.1119 33.9344C25.9344 35.7194 29.7762 36.9944 30.695 38.8337C31.5364 40.8039 31.9823 42.9203 32.0075 45.0625H2Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9919 18.9212C37.6818 18.9212 41.4838 15.1193 41.4838 10.4294C41.4838 5.73944 37.6818 1.9375 32.9919 1.9375C28.3019 1.9375 24.5 5.73944 24.5 10.4294C24.5 15.1193 28.3019 18.9212 32.9919 18.9212Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1252 22.5625L39.0352 16.4725",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6875 45.0625H43.25V43.4631C43.25 37.795 39.0931 36.88 35.1725 35.4287C33.86 34.9468 34.0831 31.5437 34.6606 30.91C35.5796 29.9139 36.2777 28.7348 36.709 27.45C37.1404 26.1652 37.2954 24.8038 37.1638 23.455",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.8a701ba8b7886bcd92cd09c56c210767.svg";
export { ForwardRef as ReactComponent };